



































import { Component, Vue, Watch } from "vue-property-decorator";
import { Route } from "vue-router";
import ScoreboardOverview from "@/views/scoreboard/ScoreboardOverview.vue";
import DepartmentScoreboard from "@/views/scoreboard/DepartmentScoreboard.vue";
import ScoreboardOptions from "@/views/scoreboard/ScoreboardOptions.vue";
import { ScoreboardSummary } from "@/api";
import moment from "moment";

@Component({
  components: {
    ScoreboardOptions,
    DepartmentScoreboard,
    ScoreboardOverview,
  },
})
export default class ScoreboardDetail extends Vue {
  isDataReady = false;
  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(newVal: Route) {
    this.departmentId = (newVal.query?.departmentId as string) ?? null;
  }

  width = this.$vuetify.breakpoint.smAndDown ? 100 + "%" : 250 + "px";

  editOption = false;

  option() {
    this.editOption = true;
  }

  get scoreboards(): ScoreboardSummary[] {
    return this.$store.getters["scoreboard/scoreboards"];
  }

  departmentId: string | null = null;

  get filterDates() {
    const beginAt = this.$store.getters["scoreboard/startDate"];
    const endAt = this.$store.getters["scoreboard/endDate"];

    if (!beginAt || !endAt) return moment().format("MMMM YYYY");

    const start = moment(beginAt, "YYYY-MM-DD");
    const end = moment(endAt, "YYYY-MM-DD");

    const isFirstDay = start.date() === 1;
    const isLastDay = end.date() === start.daysInMonth();
    if (isFirstDay && isLastDay) {
      return start.format("MMMM YYYY");
    } else {
      return `${start.format("MMMM Do YYYY")} - ${end.format("MMMM Do YYYY")}`;
    }
  }
}
